import { Button, CircularProgress } from "@mui/material";
import module from "./Wait.module.css";

function Wait() {
  const browserBack = () => {
    window.history.back();
  };

  return (
    <div className={module.container}>
      <div className={module.contents}>しばらくお待ちください</div>
      <CircularProgress color="success" className={module.contents} />
      <div className={module.contents}>
        <div className={module.contents}>画面が変わらない場合</div>
        <Button
          onClick={() => browserBack()}
          variant="outlined"
          className={module.contents}
        >
          前の画面に戻る
        </Button>
      </div>
    </div>
  );
}

export default Wait;
